<script lang="ts" setup>
import { brand } from '@/config/brands'

defineProps<{
  value: boolean
}>()

const emit = defineEmits<{
  (e: 'input', value: boolean): void
}>()

const guideImage = `/images/${brand}/chapter/reader-taboola-guide.png`

function closeGuide() {
  emit('input', false)
}
</script>

<template>
  <transition name="reader-guide-fade">
    <div
      v-if="value"
      class="reader-guide fixed inset-0 z-9999 flex items-center justify-center"
      @touchstart.stop="closeGuide"
      @click.stop="closeGuide"
      @touchmove.prevent
    >
      <img
        :src="guideImage"
        class="reader-guide-image"
        alt=""
      >
    </div>
  </transition>
</template>

<style scoped lang="scss">
.reader-guide {
  background: rgba(0, 0, 0, 0.7);
  touch-action: none;
}

.reader-guide-image {
  display: block;
  width: 163px;
  max-width: 80vw;
  height: auto;
}

.reader-guide-fade-enter-active,
.reader-guide-fade-leave-active {
  transition: opacity 0.2s ease;
}

.reader-guide-fade-enter,
.reader-guide-fade-leave-to {
  opacity: 0;
}
</style>
